import type { StreamOffsetSources } from '@/analytics/cvent/streamOffset';

import store from '@/store';

export const isOnDemandReplay = (): boolean =>
  Boolean(store.state.event?.event?.on_demand_mode && store.getters['event/currentBroadcast']?.is_available_on_demand);

export const getTimeElapsedSinceBroadcastStartMs = (): number => {
  const broadcast = store.getters['event/currentBroadcast'];
  const heartbeat = store.state.event.stage?.heartBeatDate || new Date();

  return heartbeat.getTime() - new Date(broadcast.live_start_time).getTime();
};

// Room modules hold a detached <video> with currentTime 0 until media loads.
const loadedPlayerPosition = (element: { currentTime?: number; readyState?: number } | null | undefined) =>
  element?.readyState ? element.currentTime : undefined;

export const collectStreamOffsetSources = (): StreamOffsetSources => ({
  simulivePositionSeconds: loadedPlayerPosition(store.state.simuliveroom?.hlsVideoElement),
  livePositionSeconds: loadedPlayerPosition(store.state.liveVideoRoom?.hlsVideoElm),
  // A null live_start_time would date from the epoch and yield a ~1.7e9s offset.
  elapsedSinceBroadcastStartMs: store.getters['event/currentBroadcast']?.live_start_time
    ? getTimeElapsedSinceBroadcastStartMs()
    : undefined
});
